import { IModalManager, MODAL_MANAGER, ModalStat } from '@cp/shared/modal';
import React, { PropsWithChildren, RefObject, useCallback, useLayoutEffect, useRef } from 'react';
import { useInjection } from '@cp/shared/di';
import { useDispatch } from 'react-redux';
import { isBrowser } from '@cp/utils/browser';
import { modalQueueSlice } from 'src/shared/modalProvider';
import { ModalProvider } from './modalProvider';
import { RefModalManager } from './refManager';

export const AppModalManager: React.FC<PropsWithChildren> = (props) => {
  const manageRef = useRef<IModalManager>(null);
  const statRef = useRef<ModalStat>(null);
  const manager = useInjection(MODAL_MANAGER);
  const dispatch = useDispatch();
  const onUpdate = useCallback((stat: ModalStat) => dispatch(modalQueueSlice.actions.iModalCountChange(stat.size)), [dispatch]);

  if (isBrowser) {
    // https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useLayoutEffect(() => {
      if (!(manager instanceof RefModalManager)) {
        console.warn('Can not connect modal ref to current manager');
        return;
      }
      manager.connect(manageRef as RefObject<IModalManager>);
      manager.connectStats(statRef);
      window['mm'] = manager;
      return () => manager.disconnect();
    }, [manageRef, manager]);
  }

  return (
    <>
      {props.children}
      <ModalProvider manageRef={manageRef} onUpdate={onUpdate} statRef={statRef} />
    </>
  );
};
AppModalManager.displayName = 'AppModalManager';
